import moment from "moment";
import React from "react";
import { useEffect } from "react";
import * as constants from "Constants";
import Select from "react-select";
import { useState } from "react";
import AddIcon from "@material-ui/icons/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import { Checkbox } from "@material-ui/core";

const RenderTicktsData = ({
                            item,
                            handleChange,
                            TimeZone,
                            cartItems,
                            selectedOption,
                            setSelectedOption,
                            checkDateWithinRange,
                            currentTicket,
                            recurringData,
                            shoppingCartDetails,
                            bundleSelectedQuantity,
                            setBundleSelectedQuantity,
                            isAnonymous,
                            handleAddonCheckboxChange,
                            currentAddonQuantity,
                            setShowAddonListDetail,
                            showAddonListDetail,
                          }) => {
  const [isShowInput, setIsShowInput] = useState(false);
  const [availableQnty, setAvailableQnty] = useState(0);
  const [currentCartItems, setCurrentCartitems] = useState({});
  const handleShowAddonList = (ticketId, addon) => {
    setShowAddonListDetail({ ticketId: ticketId, addonId: addon?.AddOnId });
  };

  useEffect(() => {
    const isRecData = cartItems.filter((x) => x.TicketId === item?.TicketId);
    if (
        isRecData?.length > 0 &&
        isRecData[0]?.selectedDate === selectedOption?.selectedDate &&
        isRecData[0]?.selectedSlot !== null
    ) {
      setAvailableQnty(isRecData[0]?.selectedSlot?.AvailableTickets);
      setIsShowInput(true);
      console.log("6");
    } else if (
        isRecData?.length > 0 &&
        isRecData[0]?.selectedDate === selectedOption?.selectedDate &&
        isRecData[0]?.selectedSlot == null
    ) {
      setIsShowInput(false);
      console.log("7");
    } else if (
        isRecData?.length > 0 &&
        isRecData[0]?.selectedDate === selectedOption?.selectedDate &&
        isRecData[0]?.selectedSlot !== null
    ) {
      setAvailableQnty(isRecData[0]?.selectedSlot?.AvailableTickets);
      setIsShowInput(true);
      console.log("8");
    } else if (
        isRecData?.length > 0 &&
        isRecData[0]?.selectedDate !== selectedOption?.selectedDate &&
        isRecData[0]?.selectedSlot !== null
    ) {
      setAvailableQnty(isRecData[0]?.selectedSlot?.AvailableTickets);
      setIsShowInput(true);
      console.log("8.5");
    } else if (
        selectedOption?.TicketId === item?.TicketId &&
        selectedOption?.selectedSlot == null
    ) {
      setIsShowInput(false);
      console.log("9");
    } else {
      console.log("10");
    }
  }, [selectedOption?.selectedDate]);

  useEffect(() => {
    const isRecData = cartItems.filter((x) => x.TicketId === item?.TicketId);
    if (
        isRecData?.length > 0 &&
        isRecData[0]?.selectedDate === selectedOption?.selectedDate &&
        isRecData[0]?.selectedSlot !== null
    ) {
      setAvailableQnty(isRecData[0]?.selectedSlot?.AvailableTickets);
      setIsShowInput(true);
      console.log("1");
    } else if (
        isRecData?.length > 0 &&
        isRecData[0]?.selectedDate === selectedOption?.selectedDate &&
        isRecData[0]?.selectedSlot == null
    ) {
      setIsShowInput(false);
      console.log("2");
    } else {
      if (
          selectedOption?.item?.TicketId === item?.TicketId &&
          selectedOption?.selectedSlot !== null
      ) {
        setAvailableQnty(selectedOption?.selectedSlot?.AvailableTickets);
        setIsShowInput(true);
        console.log("3");
      } else if (
          selectedOption?.TicketId === item?.TicketId &&
          selectedOption?.selectedSlot == null
      ) {
        setIsShowInput(false);
        console.log("4");
      } else {
        console.log({ selectedOption, cartItems, isRecData });
        console.log("5");
      }
    }
  }, [selectedOption?.selectedSlot]);

  const [isSaleOn, setIsSaleOn] = useState(false);
  const [saleEnded, setSaleEnded] = useState(false);
  useEffect(() => {
    if (
        moment(item?.ActiveDate, "MM/DD/YYYY hh:mm:ss A").isAfter(
            moment(
                moment().tz(TimeZone).format("MM/DD/YYYY hh:mm:ss A"),
                "MM/DD/YYYY hh:mm:ss A"
            )
        )
    ) {
      setIsSaleOn(true);
    }
    if (
        moment(item?.InActiveDate, "MM/DD/YYYY hh:mm:ss A").isBefore(
            moment(
                moment().tz(TimeZone).format("MM/DD/YYYY hh:mm:ss A"),
                "MM/DD/YYYY hh:mm:ss A"
            )
        )
    ) {
      setSaleEnded(true);
    }
  }, []);

  const handleNumberOnlyInput = (e) => {
    if (e.nativeEvent.code === "KeyE" || e.nativeEvent.code === "Minus") {
      e.preventDefault();
    }

    // return (
    //   <>
    //     <div key={item.EventId} class="body_row render-ticket-mobile">
    //       <div style={{ justifyContent: "flex-start" }} class="col_2">
    //         <div className="ticket_menu_options">
    //           {saleEnded && Number(item?.AvailableTicket) !== 0 && (
    //             <p
    //               style={{
    //                 fontWeight: 600,
    //                 color: "rgb(135, 143, 153)",
    //                 bottom: -6,
    //                 left: 36,
    //                 fontSize: 14,
    //                 padding: "20px 0px",
    //                 textAlign: "right",
    //               }}
    //             >
    //               {constants.Text.ticketSaleEnd}
    //             </p>
    //           )}

    //           {Number(item?.AvailableTicket) === 0 &&
    //             Number(item?.ReservedTicket) === 0 && (
    //               <p
    //                 style={{
    //                   fontWeight: 600,
    //                   color: "rgb(135, 143, 153)",
    //                   bottom: -6,
    //                   left: 36,
    //                   fontSize: 14,
    //                   padding: "20px 0px",
    //                   textAlign: "right",
    //                 }}
    //               >
    //                 {constants.Text.soldOut}
    //               </p>
    //             )}

    //           {Number(item?.AvailableTicket) === 0 &&
    //             Number(item?.ReservedTicket) !== 0 && (
    //               <p
    //                 style={{
    //                   fontWeight: 600,
    //                   color: "rgb(135, 143, 153)",
    //                   bottom: -6,
    //                   left: 36,
    //                   fontSize: 14,
    //                   padding: "20px 0px",
    //                   textAlign: "right",
    //                 }}
    //               >
    //                 {constants.Text.Reserved}
    //               </p>
    //             )}

    //           {isSaleOn && (
    //             <p
    //               style={{
    //                 fontWeight: 600,
    //                 color: "rgb(135, 143, 153)",
    //                 bottom: -6,
    //                 left: 36,
    //                 fontSize: 14,
    //                 textAlign: "right",
    //                 padding: "20px 0px",
    //               }}
    //             >
    //               {`On Sale ${moment(item?.ActiveDate).format("MMM DD")} at
    //                  ${moment(item?.ActiveDate).format("hh:mm A")}`}
    //             </p>
    //           )}

    //           {Number(item?.AvailableTicket) !== 0 ? (
    //             <React.Fragment>
    //               {!isSaleOn && !saleEnded && (
    //                 <Select
    //                   styles={customStyles}
    //                   // maxMenuHeight={500}
    //                   components={{
    //                     IndicatorSeparator: () => null,
    //                   }}
    //                   isSearchable={false}
    //                   // isDisabled={isSaleOn || saleEnded}
    //                   onKeyDown={handleNumberOnlyInput}
    //                   defaultValue={{
    //                     value:
    //                       defaultValue === undefined
    //                         ? 0
    //                         : cartItems.length > 0
    //                         ? Number(defaultValue?.Quantity)
    //                         : 0,
    //                     label:
    //                       defaultValue === undefined
    //                         ? 0
    //                         : cartItems.length > 0
    //                         ? defaultValue?.Quantity
    //                         : 0,
    //                   }}
    //                   // value={selectedOption}
    //                   onChange={(val) => {
    //                     handleChange(val, item);
    //                     // setSelectedOption(val);
    //                   }}
    //                   options={[
    //                     ...Array(
    //                       Number(
    //                         Number(item?.AvailableTicket) > 15
    //                           ? 16
    //                           : Number(item?.AvailableTicket) + 1
    //                       )
    //                     ).keys(),
    //                   ]?.map((i) => {
    //                     return { value: i, label: i };
    //                   })}
    //                 />
    //               )}
    //             </React.Fragment>
    //           ) : null}
    //         </div>
    //       </div>
    //       <div style={{ direction: "rtl" }} class="col_10">
    //         <h4 style={{ fontSize: 22, marginBottom: 10, fontWeight: 600 }}>
    //           {item.Title}
    //         </h4>
    //         <h5 style={{ fontSize: 20, marginBottom: 5, fontWeight: 600 }}>
    //           {item.TicketType === "0"
    //             ? "Free"
    //             : `$${Intl.NumberFormat(undefined, {
    //                 minimumFractionDigits: 2,
    //                 maximumFractionDigits: 2,
    //               }).format(item?.Price)}`}
    //         </h5>

    //         <div>
    //           {!isSaleOn && (
    //             <p style={{ color: "#878f99", fontWeight: 600 }}>
    //               {" "}
    //               {constants.Text.salesEndOn}{" "}
    //               {moment(item?.InActiveDate).format("MMM DD, yyyy")}
    //             </p>
    //           )}
    //         </div>
    //       </div>
    //     </div>
    //     {/* <div className="underline" /> */}
    //   </>
    // );
  };

  // useEffect(() => {
  const defaultValue = cartItems?.find((p) => p.TicketId === item?.TicketId);
  // if (!cartItems.length > 0) {
  //   setSelectedOption("");
  // }
  // }, [cartItems]);

  // console.log("defaultValue", defaultValue);
  const customStyles = {
    // control represent the select component
    control: (provided) => ({
      ...provided,
      width: "100px",
    }),
  };

  useEffect(() => {
    if (cartItems && cartItems.length > 0) {
      const matchingCartItem = cartItems.find(
          (cartItem) => cartItem.TicketId === item.TicketId
      );
      setCurrentCartitems(matchingCartItem);
    } else {
      setCurrentCartitems();
    }
  }, [cartItems]);

  const isAddonOutOfStockAndNotSelected = (addon, currentCartItems) => {
    const isSelected = currentCartItems?.addon?.some(
        (a) => a.AddOnId === addon.AddOnId
    );

    const totalAvailable =
        currentAddonQuantity?.[addon.AddOnId] >= 0
            ? currentAddonQuantity?.[addon.AddOnId]
            : Number(addon.QuantityAvailable) - addon.Sold;
    const remainingQty = totalAvailable - addon.Reserved;
    return remainingQty <= 0 && !isSelected;
  };

  return (
      <>
        {isAnonymous === "False" ? (
            <div
                key={item.EventId}
                className="body_row_isAnonymous render-ticket-mobile-isAnonymous"
            >
              <div style={{ justifyContent: "flex-start" }} className="col_2">
                <div className="ticket_menu_options">
                  {saleEnded && Number(item?.AvailableTicket) !== 0 && (
                      <p
                          style={{
                            fontWeight: 600,
                            color: "rgb(135, 143, 153)",
                            bottom: -6,
                            left: 36,
                            fontSize: 14,
                            padding: "20px 0px",
                            textAlign: "right",
                          }}
                      >
                        {constants.Text.ticketSaleEnd}
                      </p>
                  )}

                  {item?.RecurringTicket !== "True" &&
                      (
                          (Number(item?.AvailableTicket) === 0 && Number(item?.ReservedTicket) === 0) ||
                          (Number(item?.MinTicketRequired) > 0 &&
                              Number(item?.MinTicketRequired) > Number(item?.AvailableTicket))
                      ) && (
                          <p
                              style={{
                                fontWeight: 600,
                                color: "rgb(135, 143, 153)",
                                bottom: -6,
                                left: 36,
                                fontSize: 14,
                                padding: "20px 0px",
                                textAlign: "right",
                              }}
                          >
                            {constants.Text.soldOut}
                          </p>
                      )}

                  {item?.RecurringTicket === "True" &&
                  selectedOption?.availableSlots?.length > 0
                      ? selectedOption?.availableSlots?.every(
                      (obj) =>
                          obj.TicketId === item?.TicketId &&
                          obj.AvailableTickets == 0
                  ) && (
                      <p
                          style={{
                            fontWeight: 600,
                            color: "rgb(135, 143, 153)",
                            bottom: -6,
                            left: 36,
                            fontSize: 14,
                            padding: "20px 0px",
                            textAlign: "right",
                          }}
                      >
                        {constants.Text.soldOut}
                      </p>
                  )
                      : ""}

                  {item?.RecurringTicket !== "True" &&
                      Number(item?.AvailableTicket) === 0 &&
                      Number(item?.ReservedTicket) !== 0 && (
                          <p
                              style={{
                                fontWeight: 600,
                                color: "rgb(135, 143, 153)",
                                bottom: -6,
                                left: 36,
                                fontSize: 14,
                                padding: "20px 0px",
                                textAlign: "right",
                              }}
                          >
                            {constants.Text.Reserved}
                          </p>
                      )}

                  {isSaleOn && (
                      <p
                          style={{
                            fontWeight: 600,
                            color: "rgb(135, 143, 153)",
                            bottom: -6,
                            left: 36,
                            fontSize: 14,
                            textAlign: "right",
                            padding: "20px 0px",
                          }}
                      >
                        {`On Sale ${moment(item?.ActiveDate).format("MMM DD")} at
               ${moment(item?.ActiveDate).format("hh:mm A")}`}
                      </p>
                  )}

                  {Number(item?.AvailableTicket) !== 0 || item?.isBundle ? (
                      <React.Fragment>
                        {!isSaleOn && !saleEnded && (
                            // Radio buttons for ticket type selection when IsAnonymous is "False"
                            <div>
                              <input
                                  type="radio"
                                  name="ticketType"
                                  value={item.TicketId}
                                  // checked={selectedTicketType === item.TicketId}
                                  onChange={() => handleChange({ value: 1 }, item)}
                                  style={{ transform: "scale(2)" }}
                              />
                            </div>
                        )}
                      </React.Fragment>
                  ) : null}

                  {/*{item?.RecurringTicket === "True" && !item?.isBundle ? (*/}
                  {/*    <React.Fragment>*/}
                  {/*      {checkDateWithinRange(item?.ActiveDate, item?.InActiveDate) &&*/}
                  {/*          isShowInput && (*/}
                  {/*              <div>*/}
                  {/*                <input*/}
                  {/*                    type="radio"*/}
                  {/*                    name="ticketType"*/}
                  {/*                    value={item.TicketId}*/}
                  {/*                    // checked={selectedTicketType === item.TicketId}*/}
                  {/*                    onChange={(val) => {*/}
                  {/*                      const isRecData = cartItems.filter(*/}
                  {/*                        (x) => x.TicketId === item?.TicketId*/}
                  {/*                      );*/}

                  {/*                      isRecData.length > 0*/}
                  {/*                          ? handleChange(val, item, {*/}
                  {/*                            selectedDate: isRecData[0]?.selectedDate,*/}
                  {/*                            selectedSlot: isRecData[0]?.selectedSlot,*/}
                  {/*                          })*/}
                  {/*                          : handleChange(val, item, recurringData)*/}
                  {/*                    }}*/}
                  {/*                    style={{transform: "scale(2)"}}*/}
                  {/*                />*/}
                  {/*              </div>*/}
                  {/*          )}*/}
                  {/*    </React.Fragment>*/}
                  {/*) : null}*/}
                </div>
              </div>
              <div className="col_10">
                <h4 style={{ fontSize: 22, marginBottom: 10, fontWeight: 600 }}>
                  {item.Title}
                </h4>
                {item.Description !== "" && (
                    <h4
                        style={{
                          fontSize: 15,
                          marginBottom: 10,
                          color: "darkgray",
                          wordWrap: "break-word",
                        }}
                    >
                      {item.Description}
                    </h4>
                )}
                <h5 style={{ fontSize: 20, marginBottom: 5, fontWeight: 600 }}>
                  {item.TicketType === "0"
                      ? "Free"
                      : `${
                          shoppingCartDetails !== undefined &&
                          shoppingCartDetails !== ""
                              ? shoppingCartDetails?.CartSession.CurrencySymbol
                              : ""
                      }${Number(item?.Price).toFixed(2)}`}
                </h5>

                <div>
                  {!isSaleOn &&
                      item?.RecurringTicket === "False" &&
                      !item.isBundle && (
                      <p style={{ color: "#878f99", fontWeight: 600 }}>
                        {" "}
                        {constants.Text.salesEndOn}{" "}
                        {moment(item?.InActiveDate).format("MMM DD, yyyy")}
                      </p>
                  )}
                </div>
              </div>
            </div>
        ) : (
            <div key={item.EventId} className="body_row render-ticket-mobile">
              <div style={{ justifyContent: "flex-start" }} className="col_2">
                <div className="ticket_menu_options">
                  {saleEnded && Number(item?.AvailableTicket) !== 0 && (
                      <p
                          style={{
                            fontWeight: 600,
                            color: "rgb(135, 143, 153)",
                            bottom: -6,
                            left: 36,
                            fontSize: 14,
                            padding: "20px 0px",
                            textAlign: "right",
                          }}
                      >
                        {constants.Text.ticketSaleEnd}
                      </p>
                  )}

                  {item?.RecurringTicket !== "True" &&
                      (
                          (Number(item?.AvailableTicket) === 0 && Number(item?.ReservedTicket) === 0) ||
                          (Number(item?.MinTicketRequired) > 0 &&
                              Number(item?.MinTicketRequired) > Number(item?.AvailableTicket))
                      ) && (
                          <p
                              style={{
                                fontWeight: 600,
                                color: "rgb(135, 143, 153)",
                                bottom: -6,
                                left: 36,
                                fontSize: 14,
                                padding: "20px 0px",
                                textAlign: "right",
                              }}
                          >
                            {constants.Text.soldOut}
                          </p>
                      )}


                  {item?.RecurringTicket === "True" &&
                  selectedOption?.availableSlots?.length > 0
                      ? selectedOption?.availableSlots?.every(
                      (obj) =>
                          obj.TicketId === item?.TicketId &&
                          obj.AvailableTickets == 0
                  ) && (
                      <p
                          style={{
                            fontWeight: 600,
                            color: "rgb(135, 143, 153)",
                            bottom: -6,
                            left: 36,
                            fontSize: 14,
                            padding: "20px 0px",
                            textAlign: "right",
                          }}
                      >
                        {constants.Text.soldOut}
                      </p>
                  )
                      : ""}

                  {item?.RecurringTicket !== "True" &&
                      Number(item?.AvailableTicket) === 0 &&
                      Number(item?.ReservedTicket) !== 0 && (
                          <p
                              style={{
                                fontWeight: 600,
                                color: "rgb(135, 143, 153)",
                                bottom: -6,
                                left: 36,
                                fontSize: 14,
                                padding: "20px 0px",
                                textAlign: "right",
                              }}
                          >
                            {constants.Text.Reserved}
                          </p>
                      )}

                  {isSaleOn && (
                      <p
                          style={{
                            fontWeight: 600,
                            color: "rgb(135, 143, 153)",
                            bottom: -6,
                            left: 36,
                            fontSize: 14,
                            textAlign: "right",
                            padding: "20px 0px",
                          }}
                      >
                        {`On Sale ${moment(item?.ActiveDate).format("MMM DD")} at
               ${moment(item?.ActiveDate).format("hh:mm A")}`}
                      </p>
                  )}

                  {(item?.RecurringTicket !== "True" &&
                      Number(item?.AvailableTicket) !== 0) ||
                  item?.isBundle ? (
                      <React.Fragment>
                        {!isSaleOn &&
                            !saleEnded &&
                            (item?.isBundle ? (
                                // Original dropdown for ticket quantity when IsAnonymous is not "False"
                                <Select
                                    styles={customStyles}
                                    components={{
                                      IndicatorSeparator: () => null,
                                    }}
                                    isSearchable={false}
                                    onKeyDown={handleNumberOnlyInput}
                                    value={{
                                      value: (() => {
                                        const isRecData = cartItems.find(
                                            (x) => x.TicketId === item.TicketId
                                        );
                                        return isRecData
                                            ? isRecData.Quantity
                                            : bundleSelectedQuantity[item.TicketId] || 0;
                                      })(),
                                      label: (() => {
                                        const isRecData = cartItems.find(
                                            (x) => x.TicketId === item.TicketId
                                        );
                                        return isRecData
                                            ? isRecData.Quantity
                                            : bundleSelectedQuantity[item.TicketId] || 0;
                                      })(), // Use defaultValue
                                    }}
                                    // cartItems?.find((x) => x.TicketId === item.TicketId) ? bundleSelectedQuantity[item.TicketId] || 0, // Use defaultValue

                                    onChange={(val) => {
                                      handleChange(val, item, null, true);
                                    }}
                                    options={[...Array(Number(16)).keys()].map((i) => {
                                      return { value: i, label: i };
                                    })}
                                />
                            ) : (
                                // NON-BUNDLE TICKET SELECT
                                (() => {
                                  const available = Number(item?.AvailableTicket) || 0;
                                  const minRequired = Number(item?.MinTicketRequired) || 0;

                                  // ❌ Don't render dropdown if required tickets exceed available
                                  if (minRequired > 0 && minRequired > available) {
                                    return null;
                                  }

                                  // ✅ Build dropdown options
                                  const end = Math.min(available, 15);
                                  const arr = [{ value: 0, label: 0 }]; // always allow 0

                                  // start from minRequired if > 0, else from 1 (to avoid duplicate 0)
                                  const start = minRequired > 0 ? minRequired : 1;

                                  for (let i = start; i <= end; i++) {
                                    arr.push({ value: i, label: i });
                                  }

                                  return (
                                      <Select
                                          styles={customStyles}
                                          components={{ IndicatorSeparator: () => null }}
                                          isSearchable={false}
                                          onKeyDown={handleNumberOnlyInput}
                                          value={{
                                            value:
                                                defaultValue === undefined
                                                    ? 0
                                                    : cartItems.length > 0
                                                        ? Number(defaultValue?.Quantity)
                                                        : 0,
                                            label:
                                                defaultValue === undefined
                                                    ? 0
                                                    : cartItems.length > 0
                                                        ? defaultValue?.Quantity
                                                        : 0,
                                          }}
                                          onChange={(val) => {
                                            handleChange(val, item);
                                          }}
                                          options={arr}
                                      />
                                  );
                                })()
                            ))}
                      </React.Fragment>
                  ) : null}

                  {item?.RecurringTicket === "True" && !item?.isBundle ? (
                      <React.Fragment>
                        {checkDateWithinRange(item?.ActiveDate, item?.InActiveDate) &&
                            isShowInput && (
                                <Select
                                    styles={customStyles}
                                    // maxMenuHeight={500}
                                    components={{
                                      IndicatorSeparator: () => null,
                                    }}
                                    isSearchable={false}
                                    // isDisabled={isSaleOn || saleEnded}
                                    onKeyDown={handleNumberOnlyInput}
                                    value={{
                                      value:
                                          defaultValue === undefined
                                              ? 0
                                              : cartItems.length > 0
                                                  ? Number(defaultValue?.Quantity)
                                                  : 0,
                                      label:
                                          defaultValue === undefined
                                              ? 0
                                              : cartItems.length > 0
                                                  ? defaultValue?.Quantity
                                                  : 0,
                                    }}
                                    // value={selectedOption}
                                    onChange={(val) => {
                                      const isRecData = cartItems.filter(
                                          (x) => x.TicketId === item?.TicketId
                                      );
                                      isRecData.length > 0
                                          ? handleChange(val, item, {
                                            selectedDate: isRecData[0]?.selectedDate,
                                            selectedSlot: isRecData[0]?.selectedSlot,
                                          })
                                          : handleChange(val, item, recurringData);
                                    }}
                                    options={[
                                      ...Array(
                                          Number(
                                              Number(availableQnty) > 15
                                                  ? 16
                                                  : Number(availableQnty) + 1
                                          )
                                      ).keys(),
                                    ].map((i) => {
                                      return { value: i, label: i };
                                    })}
                                />
                            )}
                      </React.Fragment>
                  ) : null}
                </div>
              </div>
              <div style={{ direction: "rtl" }} className="col_10">
                <h4 style={{ fontSize: 22, marginBottom: 10, fontWeight: 600 }}>
                  {item.Title}
                </h4>
                {item.Description !== "" && (
                    <h4
                        style={{
                          fontSize: 15,
                          marginBottom: 10,
                          color: "darkgray",
                          wordWrap: "break-word",
                        }}
                    >
                      {item.Description}
                    </h4>
                )}
                <h5 style={{ fontSize: 20, marginBottom: 5, fontWeight: 600 }}>
                  {item.TicketType === "0"
                      ? "Free"
                      : `${
                          shoppingCartDetails !== undefined &&
                          shoppingCartDetails !== ""
                              ? shoppingCartDetails?.CartSession.CurrencySymbol
                              : ""
                      }${Number(item?.Price).toFixed(2)}`}
                </h5>

                <div>
                  {!isSaleOn &&
                      item?.RecurringTicket === "False" &&
                      !item.isBundle && (
                      <p style={{ color: "#878f99", fontWeight: 600 }}>
                        {" "}
                        {constants.Text.salesEndOn}{" "}
                        {moment(item?.InActiveDate).format("MMM DD, yyyy")}
                      </p>
                  )}
                </div>
                {item.isBundle ? (
                    bundleSelectedQuantity[item.TicketId] > 0 ? (
                        cartItems?.find(
                            (x) =>
                                x.TicketId === item.TicketId &&
                                (x.selectedSlots !== undefined &&
                                    x.selectedSlots !== null &&
                                    x.selectedSlots.length) === parseInt(item.SlotPerBundle)
                        ) ? (
                            <div>
                              {!isSaleOn && (
                                  <p style={{ color: "#47c94d", fontWeight: 600 }}>
                                    {" "}
                                    {constants.Text.bundleTicketSelectionSuccessMessage1}
                                    {item.SlotPerBundle}
                                    {constants.Text.bundleTicketSelectionSuccessMessage2}
                                  </p>
                              )}
                            </div>
                        ) : (
                            <div>
                              {!isSaleOn && (
                                  <p style={{ color: "#FF0000", fontWeight: 600 }}>
                                    {" "}
                                    {constants.Text.bundleTicketMessage1}
                                    {cartItems?.find(
                                        (x) =>
                                            x.TicketId === item.TicketId &&
                                            x.selectedSlots !== undefined &&
                                            x.selectedSlots !== null &&
                                            x.selectedSlots.length
                                    )
                                        ? cartItems.find((x) => x.TicketId === item.TicketId)
                                            .selectedSlots.length
                                        : 0}
                                    {"/"}
                                    {item.SlotPerBundle}
                                    {constants.Text.bundleTicketMessage2}
                                  </p>
                              )}
                            </div>
                        )
                    ) : (
                        <div>
                          {!isSaleOn && (
                              <p style={{ fontWeight: 600 }}>
                                {" Please select the number of people attending."}
                              </p>
                          )}
                        </div>
                    )
                ) : (
                    ""
                )}
              </div>
            </div>
        )}

        {currentCartItems?.TicketId === item.TicketId &&
        item?.AddOns?.length > 0 ? (
            <div className="add-on-container" style={{ padding: "0 10% 0 0%" }}>
              {item.AddOns?.filter((addon) => {
                const totalAvailable = Number(addon.QuantityAvailable) - addon.Sold;
                if (totalAvailable <= 0) return false;
                return true;
              })?.map((addon, index) => (
                  <>
                    <div>
                      <div
                          key={index}
                          style={{
                            width: "100%",
                            minHeight: "50px",
                            display: "flex",
                            gap: "10px",
                          }}
                      >
                        {/* Left: Color indicator box */}
                        <div
                            style={{
                              borderRadius: "10px",
                              border: `5px solid ${addon.Color}`,
                              height: "auto",
                            }}
                        ></div>

                        {/* Middle: Addon details */}
                        <div style={{
                          alignItems: "center",
                          display: "flex",
                          justifyContent: "space-between",
                          width: "100%",
                          paddingLeft: "20px"
                        }}>
                          <div>
                            <p style={{ fontSize: "16px", fontWeight: "700" }}>{addon?.Name}</p>

                            {addon?.StartDateTime && addon?.EndDateTime && TimeZone ? (
                                <p>
                                  {moment.utc(addon.StartDateTime).tz(TimeZone).format("MM/DD/YYYY")} - {" "}
                                  {moment.utc(addon.EndDateTime).tz(TimeZone).format("MM/DD/YYYY")} from {" "}
                                  {moment.utc(addon.StartDateTime).tz(TimeZone).format("h:mm A")} - {" "}
                                  {moment.utc(addon.EndDateTime).tz(TimeZone).format("h:mm A")}
                                </p>
                            ) : null}

                            <p>{addon.Description}</p>

                            {(() => {
                            const isAddonSelected = currentCartItems?.addon?.some(
                                (a) => a.AddOnId === addon.AddOnId
                            );
                            const numberOfAddonSelected =
                                currentCartItems?.addon?.filter(
                                    (a) => a.AddOnId === addon.AddOnId
                                )?.length || 0;

                            const totalAvailable =
                                currentAddonQuantity?.[addon.AddOnId] >= 0
                                    ? currentAddonQuantity?.[addon.AddOnId]
                                    : Number(addon.QuantityAvailable) - addon.Sold;
                            const remainingQty = totalAvailable - addon.Reserved;

                            if (
                                isAddonSelected &&
                                remainingQty === 0 &&
                                currentCartItems.Quantity > numberOfAddonSelected
                            ) {
                              return (
                                  <p style={{ color: "gray", fontWeight: "500" }}>
                                    Only {numberOfAddonSelected} addons can be selected
                                  </p>
                              );
                            } else if (!isAddonSelected && totalAvailable > 0 && remainingQty <= 0) {
                              return (
                                  <p style={{ color: "gray", fontWeight: "500" }}>
                                    Addons are in process of being purchased by another user
                                  </p>
                              );
                            } else if (!isAddonSelected && totalAvailable <= 0) {
                              return (
                                  <p style={{ color: "gray", fontWeight: "500" }}>{constants.Text.soldOut}</p>
                              );
                            }

                            return null;
                          })()}
                          </div>

                          {/* Right: Add/Remove icon */}
                          <div>
                            {showAddonListDetail.addonId === addon.AddOnId &&
                            showAddonListDetail.ticketId === item.TicketId ? (
                                <RemoveIcon
                                    onClick={() => handleShowAddonList("", "")}
                                    style={{
                                      background: "white",
                                      borderRadius: "50%",
                                      color: "rgb(182, 14, 181)",
                                      width: "30px",
                                      height: "30px",
                                      padding: "5px",
                                      border: "2px solid rgb(182, 14, 181)",
                                      boxShadow: "0px 1px 2px 0px #ee59ff",
                                      cursor: "pointer",
                                    }}
                                />
                            ) : (
                                <AddIcon
                                    onClick={() => {
                                      const totalAvailable =
                                          currentAddonQuantity?.[addon.AddOnId] >= 0
                                              ? currentAddonQuantity?.[addon.AddOnId]
                                              : Number(addon.QuantityAvailable) - addon.Sold;
                                      const remainingQty = totalAvailable - addon.Reserved;
                                      const isSelected = currentCartItems?.addon?.some(
                                          (a) => a.AddOnId === addon.AddOnId
                                      );

                                      if (remainingQty > 0 || isSelected) {
                                        handleShowAddonList(item.TicketId, addon);
                                      }
                                    }}
                                    style={{
                                      background: "white",
                                      borderRadius: "50%",
                                      color: isAddonOutOfStockAndNotSelected(addon, currentCartItems)
                                          ? "gray"
                                          : "rgb(182, 14, 181)",
                                      width: "30px",
                                      height: "30px",
                                      padding: "5px",
                                      border: `2px solid ${
                                          isAddonOutOfStockAndNotSelected(addon, currentCartItems)
                                              ? "gray"
                                              : "rgb(182, 14, 181)"
                                      }`,
                                      boxShadow: isAddonOutOfStockAndNotSelected(addon, currentCartItems)
                                          ? "none"
                                          : "0px 1px 2px 0px #ee59ff",
                                      cursor: isAddonOutOfStockAndNotSelected(addon, currentCartItems)
                                          ? "not-allowed"
                                          : "pointer",
                                      pointerEvents: isAddonOutOfStockAndNotSelected(addon, currentCartItems)
                                          ? "none"
                                          : "auto",
                                    }}
                                />
                            )}
                          </div>
                        </div>
                      </div>

                      {/* Lower section flipped */}
                      {showAddonListDetail.addonId === addon.AddOnId &&
                      showAddonListDetail.ticketId === item.TicketId ? (
                          <div className="add-on-item" style={{ padding: "0 30px" }}>
                            {Array.from({ length: currentCartItems?.Quantity }).map((_, i) => {
                              const isAlreadySelected = currentCartItems?.addon?.some(
                                  (a) => a.person === i + 1 && a.AddOnId === addon.AddOnId
                              );

                              const groupLimitReached =
                                  Number(currentCartItems.MaxAddOnsPerTicket) > 0 &&
                                  !isAlreadySelected &&
                                  currentCartItems.GroupAddons?.[i] >=
                                  Number(currentCartItems.MaxAddOnsPerTicket);

                              const totalAvailable =
                                  currentAddonQuantity?.[addon.AddOnId] >= 0
                                      ? currentAddonQuantity?.[addon.AddOnId]
                                      : Number(addon.QuantityAvailable) - addon.Sold;
                              const remainingQty = totalAvailable - addon.Reserved;

                              const isReservedOutOfStock = remainingQty <= 0 && !isAlreadySelected;

                              const isDisabled = groupLimitReached || isReservedOutOfStock;

                              return (
                                  <div
                                      key={i}
                                      style={{
                                        display: "flex",
                                        gap: "20px",
                                        alignItems: "center",
                                        justifyContent: "start",
                                        opacity: isDisabled ? 0.5 : 1,
                                        color: isDisabled ? "grey" : "inherit",
                                      }}
                                  >
                                    <Checkbox
                                        style={{
                                          transform: "scale(1.3)",
                                          margin: "6px",
                                          padding: "3px",
                                          marginRight: "10px",
                                        }}
                                        checked={currentCartItems?.addon?.some(
                                            (a) => a.person === i + 1 && a.AddOnId === addon.AddOnId
                                        )}
                                        color="primary"
                                        onChange={() =>
                                            handleAddonCheckboxChange(addon, item.TicketId, i + 1)
                                        }
                                        disabled={isDisabled}
                                    />
                                    <div style={{ fontSize: "14px", fontWeight: "600" }}>
                                      {shoppingCartDetails?.CartSession?.CurrencySymbol ?? ""}
                                      {Number(addon?.Price).toFixed(2)}
                                    </div>
                                    <div style={{ fontSize: "14px", fontWeight: "600" }}>
                                      Add to {item.Title} Ticket {i + 1}
                                    </div>
                                  </div>
                              );
                            })}
                          </div>
                      ) : null}
                    </div>
                  </>
              ))}
            </div>
        ) : null}
      </>
  );
};
export default RenderTicktsData;
